<template>
  <div
  class="dot"
  :class="[size, color, {
    'selected': selected
  }]"
  />
</template>
<script setup lang="ts">
import { type TypeSize, Color, type TypeColor } from '../../interfaces'
export interface PropsDot {
  selected?: boolean
  size?: TypeSize
  color?: TypeColor
}
withDefaults(defineProps<PropsDot>(), {
  selected: false,
  color: Color.white
})
</script>
<style lang="scss" scoped>
$width: 0.75rem;
$width-sm: 0.75rem;
$border-width: 1px;
$animation-duration: 0.5s;
$start: right;
$end: left;
.dot {
  width: $width;
  height: $width;
  border-radius: 50%;
  display: block;
  transition: all $animation-duration ease-out;
  &.sm {
    width: $width-sm;
    height: $width-sm;
  }
  $white: var(--button-primary-white-background-color);
  &.white {
    border: $border-width solid $white;
    background: linear-gradient(to $start, $white 50%, transparent 50%);
    background-size: 200% 100%;
    background-position: $start bottom;
    &.selected {
      background-position: $end bottom;
    }
  }

  $sun: var(--button-primary-sun-background-color);
  &.sun {
    border: $border-width solid $sun;
    background: linear-gradient(to $start, $sun 50%, transparent 50%);
    background-size: 200% 100%;
    background-position: $start bottom;
    &.selected {
      background-position: $end bottom;
    }
  }
  $cork: var(--button-primary-cork-background-color);
  &.cork {
    border: $border-width solid $cork;
    background: linear-gradient(to $start, $cork 50%, transparent 50%);
    background-size: 200% 100%;
    background-position: $start bottom;
    &.selected {
      background-position: $end bottom;
    }
  }

  $pink: var(--button-primary-pink-background-color);
  &.pink {
    border: $border-width solid $pink;
    background: linear-gradient(to $start, $pink 50%, transparent 50%);
    background-size: 200% 100%;
    background-position: $start bottom;
    &.selected {
      background-position: $end bottom;
    }
  }
}

// FOR DEMO
// .dot:hover {
//   background-position: $end bottom;
// }

</style>
